import { TableColumn, User } from '@/types';
import StatusBadge from '@/components/ui/StatusBadge';

export const userSelectionColumns: TableColumn<User>[] = [
  {
    key: 'fullName',
    header: 'Nombre',
    accessor: (user) => (
      <div className="font-medium text-gray-900">{user.fullName}</div>
    ),
  },
  {
    key: 'username',
    header: 'Usuario',
  },
  {
    key: 'status',
    header: 'Estado',
    accessor: (user) => <StatusBadge status={user.status} />
  }
];
